import { Button } from '@billda/design-system';
import { SaveIcon, CancelIcon } from '@billda/design-system';

interface GroupFormActionsProps {
  onCancel: () => void;
  onSubmit: () => void;
  submitLabel: string;
  disabled?: boolean;
  loading?: boolean;
  status?: string;
  cancelTestId?: string;
  submitTestId?: string;
}

export function GroupFormActions({
  onCancel,
  onSubmit,
  submitLabel,
  disabled = false,
  loading = false,
  status,
  cancelTestId = 'cancel-button',
  submitTestId = 'submit-button',
}: GroupFormActionsProps) {
  return (
    <div className="border-t border-border-default pt-4">
      {status ? (
        <p className="type-caption mb-2 text-content-secondary">{status}</p>
      ) : null}
      <div className="flex gap-3">
        <Button
          variant="outline"
          onClick={onCancel}
          disabled={loading}
          data-testid={cancelTestId}
          fullWidth
        >
          <CancelIcon aria-hidden="true" className="size-4" />
          Cancel
        </Button>
        <Button
          variant="neutral"
          onClick={onSubmit}
          disabled={disabled || loading}
          loading={loading}
          data-testid={submitTestId}
          fullWidth
        >
          {!loading ? <SaveIcon aria-hidden="true" className="size-4" /> : null}
          {submitLabel}
        </Button>
      </div>
    </div>
  );
}
